<template>
  <div class="recipe-full-details">
    <div class="heading-bar">
      <button type="button" class="close" aria-label="Close" @click="close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div>
      <div
        :class="imageStyles"
        v-if="blok.show_details_image"
        :style="`background-image: url(${recipe.image_urls.l}`"
      ></div>
      <div class="recipe-title">{{ recipe.title }}</div>
      <div class="recipe-description">{{ recipe.description }}</div>
      <div class="recipe-macros" v-if="blok.show_details_further_info">
        <div class="macro calories">
          <span class="label">Calories:</span>
          {{ recipe.macros.calories }}
        </div>
        <div class="macro cook-time">
          <span class="label">Cooking Time:</span>
          {{ recipe.cooking_time_in_minutes }}min
        </div>
        <div class="macro fat">
          <span class="label">Fat:</span>
          {{ recipe.macros.fat }}g
        </div>
        <div class="macro carbs">
          <span class="label">Carbs:</span>
          {{ recipe.macros.carbs }}g
        </div>
        <div class="macro protien">
          <span class="label">Protein:</span>
          {{ recipe.macros.protein }}g
        </div>
        <div class="recipe-cuisine">
          <span class="label">Cuisine:</span>
          {{ recipe.cuisine }}
        </div>
      </div>
      <div class="more-details" v-if="blok.show_details_further_info">
        <div class="recipe-ingredients">
          <span class="label">Ingredients:</span>
          {{ recipe.ingredients.join(', ') }}
        </div>
      </div>
      <div v-if="!hidePrices">
        <div class="recipe-price">
          <span v-mny="{ input: recipe_price, currency: 'GBP' }"></span>
        </div>
        <div class="recipe-price-per-person">
          (
          <span v-mny="{ input: per_person, currency: 'GBP' }"></span>&nbsp;per person)
        </div>
      </div>
    </div>
    <div v-if="!disablePurchase" class="recipe-add-button">
      <span v-if="!isInCart(recipe)">
        <button
          v-if="!disablePurchase"
          @click="addToBasket"
          class="btn btn-primary card-button"
        >Add to my box</button>
      </span>
      <span v-else>
        <button
          v-if="!disablePurchase"
          @click="removeFromBasket"
          class="btn btn-primary card-button"
        >Remove from my box</button>
      </span>
    </div>
    <div class="footer-bar">
      <button type="button" class="close" aria-label="Close" @click="close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <hr class="dividor">
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { basketBase } from "../../../components/cart/basketBase";

export default {
  name: "recipe-details-basic",
  mixins: [ basketBase ],
  props: {
    recipe: Object,
    blok: Object,
    hidePrices: Boolean,
    disablePurchase: Boolean,
    allowDetails: Boolean
  },
  computed: {
    ...mapState({
        meal_preferences: state => state.profile.meal_preferences
    }),
    imageStyles: function() {
      return [
        "recipe-image image-blok",
        this.$props.blok.details_image_width,
        this.$props.blok.details_image_scale
      ];
    },
    recipe_price: function() {
        return (this.recipe.fractional_prices_for_portions[this.meal_preferences.people]/100)
    },
    per_person: function() {
        return this.recipe_price / this.meal_preferences.people;
    }
  },
  methods: {
    close: function() {
      this.$emit('close');
    },
    addToBasket: function() {
        this.$emit('addToBasket',{recipe: this.recipe, index: 0});
    },
    removeFromBasket: function() {
        this.$emit('removeFromBasket',{ recipe: this.recipe, index: 0 });
    }
  }
};
</script>
